import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";

const AdminBannerBoxPC = styled.div`
    height: 267px;
    margin-bottom: 3rem;
`;

const AdminBannerBoxMobile = styled.div`
    height: 125px;
    margin-bottom: 3rem;
`;

export const AdminBannerBox = styledByDevice(AdminBannerBoxPC, AdminBannerBoxMobile);